import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {Obligor} from "../model/pro-report/HeaderDetails";
import {RecentSearch} from "../model/RecentSearch";
import {ActionType} from "../model/enum/action-type";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class TrackService {


  constructor(private http: HttpClient) {

  }

  public track(obligorId: number, actionType: ActionType, recentSearch: RecentSearch): Observable<any> {
    if (!recentSearch) {
      recentSearch = new RecentSearch(null, null, null);
      recentSearch.state = null;
    }
    return this.http.post<any>(environment.apiUrl + "/tracking", {
      "actionType": actionType,
      "obligorID": obligorId,
      "keyWords": recentSearch.keywords,
      "cusip": recentSearch.cusip,
      "stateID": recentSearch.state == null ? null : recentSearch.state.stateId
    });
  }

}
